export default {"src":"/_next/static/media/arrawIcon-3.3e293b46.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};